export function setOpacity(color: string, opacity: number): string {
  if (color.startsWith('#')) {
    const bigint = parseInt(color.slice(1), 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }

  const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
  if (!match) {
    console.error('Invalid color format')
    return color
  }

  const [_, r, g, b] = match

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export const Color = {
  setOpacity,
}
